/**
 * Maps the raw gateway and settlement statuses used by paydeck-api onto the
 * small set of states the UI shows. Mirrors mixins/verifier.js in paydeck-web.
 */
export const STATUS = {
  settled: { label: 'Settled', tone: 'success', icon: 'check' },
  processing: { label: 'Processing', tone: 'info', icon: 'loader' },
  pending: { label: 'Pending', tone: 'warning', icon: 'clock' },
  failed: { label: 'Failed', tone: 'danger', icon: 'x' },
  awaiting: { label: 'Awaiting payment', tone: 'warning', icon: 'clock' },
  notStarted: { label: 'Not started', tone: 'neutral', icon: 'circle' },
  verified: { label: 'Verified', tone: 'success', icon: 'check' },
  approved: { label: 'Approved', tone: 'success', icon: 'check' },
  inReview: { label: 'Awaiting approval', tone: 'warning', icon: 'clock' },
  required: { label: 'Pending submission', tone: 'danger', icon: 'alert' },
  claimed: { label: 'Claimed', tone: 'success', icon: 'check' },
  unclaimed: { label: 'Unclaimed', tone: 'neutral', icon: 'circle' },
  refunded: { label: 'Refunded', tone: 'info', icon: 'undo' },
  disputed: { label: 'Disputed', tone: 'danger', icon: 'alert' },
  notCompleted: { label: 'Not completed', tone: 'neutral', icon: 'x' },
  unknown: { label: 'Unknown', tone: 'neutral', icon: 'circle' },
};

// Every raw transaction_status found in the data (UX guide 6.2). Decision D2: the Refund
// Initiated and Chargeback Filed rows are real, so they get their own buckets.
const RAW = {
  processing: ['CHARGED', 'captured', 'paid', 'success', 'Processing', 'authorized', 'AUTHORIZING'],
  pending: ['CREATED', 'created', 'NEW', 'initiated', 'STARTED', 'Payment Pending', 'PENDING_VBV', 'PENDING'],
  awaiting: ['Waiting for Acceptance'],
  failed: ['AUTHORIZATION_FAILED', 'AUTHENTICATION_FAILED', 'Failed', 'failed', 'failure', 'userCancelled', 'ERROR', 'error', 'invalid_request_error', 'NOT_FOUND'],
  refunded: ['Refund Initiated', 'Payment Reversed'],
  disputed: ['Chargeback Filed'],
  settled: ['Completed'],
};

// A checkout nobody paid within this time was abandoned; banks confirm real payments well before.
export const ABANDONED_AFTER = 30 * 60 * 1000;

/**
 * Bucket for a transaction row. Settled wins when settlement_utr is PAID. NOT_FOUND on an
 * invoice request means it is still awaiting payment. Pending rows older than 30 minutes show
 * as "Not completed" (an abandoned checkout). Anything unknown is "unknown", never silently pending.
 */
export function txnStatus(txn) {
  if (!txn) return 'unknown';
  if (txn.settlement_utr === 'PAID') return 'settled';
  const s = txn.transaction_status;
  if (s === 'NOT_FOUND' && txn.transaction_type === 'invoice') return 'awaiting';
  const k = Object.keys(RAW).find((key) => RAW[key].includes(s));
  if (!k) return 'unknown';
  if (k === 'pending') {
    const t = new Date(txn.createdAt || txn.transaction_initiation_date || 0).getTime();
    if (t && Date.now() - t > ABANDONED_AFTER) return 'notCompleted';
  }
  return k;
}

/** Raw statuses per bucket, for server side filters. */
export const STATUS_RAW = RAW;
